import lazyWithReload from 'config/ChunkReload';
import { menuBuilder } from 'services/Routes.service';
import { SoftwaresIcon } from '@edusynch/edusynch-svg-icons';

const ExternalSoftwaresList = lazyWithReload(() =>
  import(
    'modules/Softwares/ExternalSoftwares/ExternalSoftwaresList/ExternalSoftwaresList.container'
  )
);

const VersionsList = lazyWithReload(() =>
  import('modules/Softwares/Versions/VersionsList/VersionsList.container')
);

const IntegrationsList = lazyWithReload(() =>
  import(
    'modules/Softwares/Integrations/IntegrationsList/IntegrationsList.container'
  )
);

const APIUsersList = lazyWithReload(() =>
  import('modules/Softwares/APIUsers/APIUsersList/APIUsersList.container')
);

const ApplicationTokensList = lazyWithReload(() =>
  import(
    'modules/Softwares/ApplicationTokens/ApplicationTokensList/ApplicationTokensList.container'
  )
);

const SoftwaresMenu = menuBuilder([
  {
    Icon: SoftwaresIcon,
    name: 'Softwares',
  },
]).addSubmenu([
  {
    type: '',
    name: 'External Softwares',
    path: '/external_softwares',
    exact: true,
    component: ExternalSoftwaresList,
    ability: 'softwares',
  },
  {
    type: '',
    name: 'Versions',
    path: '/versions',
    exact: true,
    component: VersionsList,
    ability: 'softwares',
  },
  {
    type: '',
    name: 'Integrations',
    path: '/integrations',
    exact: true,
    component: IntegrationsList,
    ability: 'softwares',
  },
  {
    type: '',
    name: 'API Users',
    path: '/api_users',
    exact: true,
    component: APIUsersList,
    ability: 'softwares',
  },
  {
    type: '',
    name: 'Application Tokens',
    path: '/application_tokens',
    exact: true,
    component: ApplicationTokensList,
    ability: 'softwares',
  },
]);

export default SoftwaresMenu;
